// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-index-jsx": () => import("/Users/yousuf/Sites/doubledip/double.us/src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */)
}

exports.data = () => import("/Users/yousuf/Sites/doubledip/double.us/.cache/data.json")

